// extracted by mini-css-extract-plugin
export default {"btnSaveContainer":"styles-scoped__btnSaveContainer--HO8ue","btnSave":"styles-scoped__btnSave--PiaKY"};